import type { Evento, Invitacion } from '@eventos-cien/shared';
import type { MesaConId, UsuarioConId } from './AdminEventoDataProvider';

function celda(valor: string | number | null | undefined): string {
  const texto = valor == null ? '' : String(valor);
  return /[",\n]/.test(texto) ? `"${texto.replaceAll('"', '""')}"` : texto;
}

const ENCABEZADOS = [
  'Nombre',
  'Acompañante',
  'Lleva acompañante',
  'Pareja sin acompañante',
  'Teléfono',
  'Últimos 4',
  'Cupo',
  'Estado',
  'Origen',
  'Asesor',
  'Mesa',
  'Prioridad',
  'Titular presente',
  'Acompañante presente',
  'Registrado en',
];

/** Genera y descarga un CSV con la base completa de invitaciones del evento. */
export function exportarInvitacionesCSV(
  evento: Evento,
  invitaciones: Invitacion[],
  mesas: MesaConId[],
  usuarios: UsuarioConId[],
) {
  const nombreAsesor = new Map(usuarios.map((u) => [u.uid, u.nombre]));
  const nombreMesa = new Map(mesas.map((m) => [m.id, `Mesa ${m.numero}`]));

  const filas = invitaciones
    .filter((i) => i.estado === 'registrada')
    .map((i) => {
      const parejaSinAcompanante = i.cupo === 2 && !i.invitado.acompanante;
      const llevaAcompanante = i.cupo !== 2 ? '' : i.invitado.acompanante ? 'sí' : 'no';

      return [
        i.invitado.nombre,
        i.invitado.acompanante,
        llevaAcompanante,
        parejaSinAcompanante ? 'SÍ' : '',
        i.invitado.telefono,
        i.telefonoUlt4,
        i.cupo,
        i.estado,
        i.origen,
        nombreAsesor.get(i.asesorUid) ?? i.asesorUid,
        i.mesaId ? (nombreMesa.get(i.mesaId) ?? i.mesaId) : '',
        i.prioridad ?? '',
        i.asistencia.titular.presente ? 'sí' : 'no',
        i.asistencia.acompanante.presente ? 'sí' : 'no',
        i.registradoEn ?? '',
      ]
        .map(celda)
        .join(',');
    });

  const csv = [ENCABEZADOS.map(celda).join(','), ...filas].join('\r\n');
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `invitados-${evento.nombre.toLowerCase().replaceAll(/\s+/g, '-')}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
